import "./styles/main.css";

import { ScrollTrigger } from "gsap/ScrollTrigger";

import { initContact } from "./modules/contact";
import { initCountdown } from "./modules/countdown";
import { loaderTask, runLoader } from "./modules/loader";
import {
  initBrand,
  initHeader,
  initLineReveal,
  initReveals,
  initSmoothScroll,
} from "./modules/interactions";
import { initLang } from "./modules/lang";
import { initLegal } from "./modules/legal";
import { initNetworkWater, initPlatformWater } from "./modules/sectionWater";
import { initStreams } from "./modules/streams";
import { initSwitch } from "./modules/switch";
import { initTheme } from "./modules/theme";
import { initBuilding, initVisuals } from "./modules/visuals";
import { initWater } from "./modules/water";
import { initWaveBands } from "./modules/waves";

const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
const loading = runLoader();
const arriving = initSwitch();

initTheme();
initBrand();
initSmoothScroll(reduced);
initVisuals();
initLineReveal();
const intro = initReveals(reduced);
initHeader();
initStreams(reduced);
initWaveBands(reduced);
initCountdown(reduced);
initContact();
initLegal();
initLang();

const hero = document.querySelector<HTMLElement>("[data-hero]");
const water = document.querySelector<HTMLCanvasElement>("[data-water]");
if (hero && water) initWater(water, hero, reduced);
requestAnimationFrame(() => requestAnimationFrame(() => loaderTask("water")));
initPlatformWater(reduced);
initNetworkWater(reduced);
const building = document.querySelector<HTMLCanvasElement>("[data-building]");
if (building) initBuilding(building, reduced);

const start = () => {
  ScrollTrigger.refresh();
  void Promise.all([loading, arriving]).then(() => intro.play());
};
if (document.readyState === "complete") start();
else window.addEventListener("load", start, { once: true });
